import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { StyledIconPropsType } from './types'

const CloseIconWMO = ({ 
  icon = "close",
  color= "dark-2",
  viewBox = "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps = {}
 }: StyledIconPropsType) => {
  return (
    <StyledIcon
      width={width}
      height={height}
      viewBox={viewBox}
      a11yTitle={icon}
      color={color}
      {...customProps}
    >
    <g clipPath="url(#clip0_2355_329454)">
      <path d="M25.3307 8.5465L23.4507 6.6665L15.9974 14.1198L8.54406 6.6665L6.66406 8.5465L14.1174 15.9998L6.66406 23.4532L8.54406 25.3332L15.9974 17.8798L23.4507 25.3332L25.3307 23.4532L17.8774 15.9998L25.3307 8.5465Z" fill="#333333"/>
    </g>
    <defs>
      <clipPath id="clip0_2355_329454">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
    </StyledIcon>
  )
}

export default CloseIconWMO
